import TRANSLATE_EN from "./en/translations.json";

import TRANSLATE_CS from "./cs/translations.json";


export const translations = {
    en: { translation: TRANSLATE_EN },

    cs: { translation: TRANSLATE_CS },

}
